import './index.scss';

import '@splidejs/splide/css/core';

import Splide from '@splidejs/splide';

class ImageSlider {
    constructor(root) {
        this.root = root;
        this.navLocked = false;
        this.navUnlockTimer = null;

        const splide = this.root.querySelector('.splide');
        if (!splide) {
            return;
        }

        // Same idea as History / Text and Image Slider: slide (no loop), stop at ends.
        // perMove: 1 — always advance one slide, even when multiple are visible.
        this.splide = new Splide(splide, {
            gap: 16,
            pagination: false,
            mediaQuery: 'min',
            perPage: 1,
            perMove: 1,
            breakpoints: {
                768: {
                    perPage: 2,
                    perMove: 1,
                    gap: 24,
                },
                1280: {
                    perPage: 2,
                    perMove: 1,
                    gap: 32,
                },
                1920: {
                    perPage: 2,
                    perMove: 1,
                    gap: 40,
                },
            },
        });

        this.splide.mount();

        this.buttonPrev = this.root.querySelector('.splide__arrow--prev');
        this.buttonNext = this.root.querySelector('.splide__arrow--next');

        this.bindArrow(this.buttonPrev);
        this.bindArrow(this.buttonNext);

        this.splide.on('moved resized updated refreshed', () => {
            this.clearNavUnlockTimer();
            this.navLocked = false;
        });

        // Splide toggles disabled at ends; blur so focus does not linger on a hidden control.
        this.splide.on('arrows:updated', (prev, next) => {
            this.blurIfDisabled(prev);
            this.blurIfDisabled(next);
        });
    }

    bindArrow(button) {
        if (!button) {
            return;
        }

        // Capture phase: gate rapid double click/tap before Splide's own handler.
        button.addEventListener('click', (event) => {
            this.onArrowClick(event);
        }, true);
        button.addEventListener('dblclick', (event) => {
            event.preventDefault();
        });
    }

    onArrowClick(event) {
        if (this.navLocked || this.splide.Components.Controller.isBusy()) {
            event.preventDefault();
            event.stopImmediatePropagation();
            return;
        }

        this.navLocked = true;
        this.clearNavUnlockTimer();
        this.navUnlockTimer = window.setTimeout(() => {
            this.navUnlockTimer = null;
            this.navLocked = false;
        }, 450);
    }

    clearNavUnlockTimer() {
        if (this.navUnlockTimer !== null) {
            window.clearTimeout(this.navUnlockTimer);
            this.navUnlockTimer = null;
        }
    }

    blurIfDisabled(button) {
        if (button && button.disabled && document.activeElement === button) {
            button.blur();
        }
    }
}

window.app.run(() => {
    document.querySelectorAll('.image-slider').forEach((node) => {
        new ImageSlider(node);
    });
});
